import { Fragment } from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import { useTheme, FONT_SIZE } from '@shopify/polaris-viz-core';

function TextLine({
  index,
  line
}) {
  const selectedTheme = useTheme();
  return /*#__PURE__*/jsx(Fragment, {
    children: line.map(({
      dominantBaseline,
      height,
      fullText,
      truncatedText,
      textAnchor,
      transform,
      width,
      x,
      y
    }, textIndex) => {
      const key = `${index}-${textIndex}-${truncatedText}`;
      return /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("text", {
          textAnchor: textAnchor,
          dominantBaseline: dominantBaseline,
          height: height,
          width: width,
          x: x,
          y: y,
          fill: selectedTheme.xAxis.labelColor,
          fontSize: FONT_SIZE,
          transform: transform,
          children: truncatedText
        }), /*#__PURE__*/jsx("title", {
          children: fullText
        })]
      }, key);
    })
  });
}

export { TextLine };
